import styled from 'styled-components'

interface Style {
  columnNumber: number
  width?: any
  columnsWidths?: number[]
  columnGap?: number
}

export const Table = styled.div`
  width: fit-content;
  border-radius: 8px;
  border: 1px solid #eeeeee;
`
export const Header = styled.div`
  width: ${(props: Style) => {
    if (props.width) return props.width
    return 'fit-content'
  }};
  grid-template-columns: ${(props: Style) => {
    if (props.columnsWidths) return `${props.columnsWidths.join('px ')}px`
    return 'auto'
  }};
  gap: 0 ${(props: Style) => (props.columnGap ? `${props.columnGap}px` : '0px')};
  display: grid;
  padding-left: 16px;
  background: #f5f5f5;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  .grid-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 12px 0;
    cursor: pointer;
    border: none;
    gap: 2px;
    border-bottom: 1px solid #eeeeee;
    background-color: transparent;
    color: #757575;
    font-family: 'Inter';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 133.333% */
    letter-spacing: 0.48px;
    text-transform: uppercase;
  }
`
export const TableContent = styled.div`
  width: ${(props: Style) => {
    if (props.width) return props.width
    return 'fit-content'
  }};
  min-height: 350px;
  padding-left: 16px;
  display: grid;
  gap: 0 ${(props: Style) => (props.columnGap ? `${props.columnGap}px` : '0px')};
  grid-template-columns: ${(props: Style) => {
    if (props.columnsWidths) return `${props.columnsWidths.join('px ')}px`
    return 'auto'
  }};

  grid-auto-rows: 73px;
  .table-cell {
    display: flex;
    align-items: center;
    max-width: 100%;
    overflow: hidden;
  }
  .grid-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    padding: 16px 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    gap: 8px;
    color: #1c1d22;
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    border-bottom: 1px solid #eeeeee;
  }
  .grid-action {
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: flex-start;
    gap: 16px;
    border-bottom: 1px solid #eeeeee;
    img {
      width: 16px;
      height: 16px;
    }
  }
`
export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background: #f5f5f5;
  border-bottom: 1px solid #eeeeee;
  color: #757575;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.48px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  .table-chevron {
    border-radius: 6px;
    box-shadow: 0px 2px 5px 0px rgba(89, 96, 120, 0.1),
      0px 0px 0px 1px rgba(254, 237, 178, 0.16),
      0px 1px 1px 0px rgba(254, 237, 178, 0.1);
    width: 16px;
    height: 16px;
    filter: brightness(0) saturate(100%) invert(44%) sepia(0%) saturate(1670%)
      hue-rotate(175deg) brightness(102%) contrast(75%);
    cursor: pointer;
  }
  .right-container {
    display: flex;
    gap: 20px;
  }
  .pagination-container {
    display: flex;
    gap: 10px;
  }
`
